import { Component, OnInit, Input } from '@angular/core';
import { INote } from 'src/app/intefaces/INote';

@Component({
  selector: 'app-track-list',
  templateUrl: './track-list.component.html',
  styleUrls: ['./track-list.component.scss']
})
export class TrackListComponent implements OnInit {
  @Input() trackList: Array<INote>;
  @Input() isSearch: boolean;

  constructor() { }

  ngOnInit(): void {

  }

}
